import React, { useContext, useEffect, useState } from "react";
import * as GrIcons from "react-icons/gr";
import * as FaIcons from "react-icons/fa";
import LoadingSpinner from "../utilities/LoadingSpinner";
import moment from "moment";

import AdminRestrationContext from "../../context/adminRegistration/adminRegistrationContext";
import AuthContext from "../../context/auth/authContext";

import RegistrationContext from "../../context/registration/registrationContext";

import ScheduleOrientation from "./ScheduleOrientation";
import OrientationConfirmation from "./OrientationConfirmation";

import StudentMatchComponent from "../../components/registrationAdmin/StudentMatchComponent";
import PendingActionConfirmation from "../../components/registrationAdmin/PendingActionConfirmation";

import ProcessLevelBar from "./ProcessLevelBar";

const ProcessRegistrationModal = () => {
  const [showScheduleOrientation, setShowScheduleOrientation] = useState(false);
  const adminRegistrationContext = useContext(AdminRestrationContext);
  const {
    setFormModal,
    registration,
    updateProcessingLevel,
    getStudentMatchResults,
  } = adminRegistrationContext;
  const {
    _id,
    processingLevel,
    firstName,
    orientationScheduled,
    status,
    lastName,
    birthDate,
    studentPrimaryPhone,
    learningCenterCharter,
  } = registration;
  const [pendingAction, setPendingAction] = useState(
    status === "Auto Withdraw Requested" ||
      status === "Interdistrict Transfer Requested"
  );

  useEffect(() => {
    getStudentMatchResults({
      firstName,
      lastName,
      birthDate:
        birthDate === ""
          ? birthDate
          : moment(birthDate).utc().format("MM/DD/yyyy"),
      phone: studentPrimaryPhone,
      charterName: learningCenterCharter,
      address: "",
      email: "",
    });
  }, [firstName]);

  return (
    <div id="process-registration-modal" className="modal">
      <div
        className="process-registration-content modal-content"
        style={{ width: processingLevel === 0 ? "100%" : "75%" }}
      >
        <div className="top-bar">
          <GrIcons.GrFormClose
            className="close-icon"
            onClick={() => setFormModal("processRegistrationModal", false)}
          />
          <ProcessLevelBar level={processingLevel} />
        </div>
        <div className="modal-body">
          {processingLevel === 0 && (
            <StudentMatchComponent
              type="POST"
              id={_id}
              setPendingAction={setPendingAction}
            />
          )}
          {processingLevel === 1 &&
            (pendingAction ? (
              <PendingActionConfirmation setPendingAction={setPendingAction} />
            ) : orientationScheduled && !showScheduleOrientation ? (
              <OrientationConfirmation
                showScheduleOrientation={setShowScheduleOrientation}
              />
            ) : (
              <div className="reschedule-orientation">
                {orientationScheduled && (
                  <div className="rebtn-container">
                    <div
                      className="flex-btn"
                      onClick={() => setShowScheduleOrientation(false)}
                    >
                      <FaIcons.FaArrowLeft className="cancel-icon" />
                      <p>Cancel Reschedule</p>
                    </div>
                  </div>
                )}
                <ScheduleOrientation type="POST" />
              </div>
            ))}
          {processingLevel === 2 && (
            <div className="processing-complete-screen">
              <p>{`Registration Processing is complete.`}</p>
              <p>{`${firstName} is now orientation ready!`}</p>
              <FaIcons.FaCheckCircle className="complete-icon" />
            </div>
          )}
          {/* <div className="progress-btns">
            <div
              className="progress-btn"
              onClick={() => {
                if (processingLevel > 0) {
                  updateProcessingLevel(processingLevel - 1);
                }
              }}
            >
              <FaIcons.FaChevronLeft className="progress-icon" />
            </div>
            <div
              className="progress-btn"
              onClick={() => {
                if (processingLevel <= 3) {
                  updateProcessingLevel(processingLevel + 1);
                }
              }}
            >
              <FaIcons.FaChevronRight className="progress-icon" />
            </div>
          </div> */}
        </div>
        <div className="bottom-bar">
          <div className="btns">
            <div
              className="btn btn-l4l-dark"
              onClick={() => setFormModal("processRegistrationModal", false)}
            >
              Close
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProcessRegistrationModal;
